import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CmsLayout, RepeatPresSetDto, RepeatPresCol, RepeatPresRow, RepeatPresGroup, cmsRepeatPres, RepeatPresStyle, RepeatData } from '../repeated-pres-models';
import { HistApi } from 'src/app/services/api-service/hist/hist-api';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { RegisterApi } from 'src/app/services/api-service/register/register-api';
import { CmsReport, CmsReportApi } from 'src/app/services/api-service/cms-report/cms-report-api';
import { DrugBagInfo, RepeatedPrescriptionDto } from 'src/app/services/api-service/hist/whole-large-hist';
import { UserCache } from 'src/app/services/user-cache';
import { Clinic } from 'src/app/system/clinic/models/clinic';
import * as QRCode from 'qrcode';
import { HistOrder } from 'src/app/hist/models/hist-order';
import { fixSpecialChar, isSpecialChar } from 'src/app/shared/utilities';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { OrderDispensingTypeEnum } from 'src/app/enums/DispensingTypeEnum';
import { CmsColDataCalc, cmsMarginCss } from '../../receipt-models';
import { HistRxDispPresConst } from 'src/app/shared/constants/hist-rx-const';

export enum RepeatedPresReportType {
  Prescription = 'Prescription', //處方箋
  DispExam = 'DispExam', //檢驗單
  CtrDrugs = 'CtrDrugs', //管制藥品處方箋
}

@Component({
  selector: 'app-repeated-pres-dynamic',
  templateUrl: './repeated-pres-dynamic.component.html',
  styleUrls: ['./repeated-pres-dynamic.component.css']
})
export class RepeatedPrescriptionDynamicComponent implements OnInit, AfterViewInit {

  private defaultFontSize = 14;
  private defaultFontFamily = '細明體';

  private data: RepeatData;
  private report: CmsReport;
  //預設是處方箋
  @Input()
  reportType: RepeatedPresReportType = RepeatedPresReportType.CtrDrugs;
  sevenHRx: HistOrder[] = [];
  /** 須單獨成張的醫令，於 getHtml 尾端另外輸出一張；僅非連處會有值 */
  specialHRx: HistOrder[] = [];
  pageHRx: HistOrder[][] = [];
  checkSeven = false;
  isPrintItreatnum = true;
  IsPrintAfterSevenDispPrescription: boolean = true;
  tmpRepeatPresDto: RepeatedPrescriptionDto;
  printRxType: number[] = [];

  @Input()
  set cmsData(v: cmsRepeatPres) {
    this._cmsData = v;
    this.updatePrintStyle();
  }
  _cmsData = new cmsRepeatPres();
  clinic: Clinic;
  get cmsData() {
    return this._cmsData;
  }
  @ViewChild('reportContainer', { static: false })
  reportContainer: ElementRef<HTMLDivElement>;
  @ViewChild('qrcodeItreatnumImg')
  qrcodeItreatnumImg: ElementRef<HTMLImageElement>
  constructor(private histApi: HistApi,
    private regApi: RegisterApi,
    private cmsReportApi: CmsReportApi,
    private clinicData: ClinicDataService,
    private cdr: ChangeDetectorRef
  ) { }

  async ngOnInit() {

  }
  async ngAfterViewInit() {
    await this.updatePrintStyle()
  }

  async getReport(code: string) {
    try {
      this.report = await this.cmsReportApi.GetPrintByCode(code) as CmsReport;
      if (!this.report) {
        throw '找不到報表'
      }
      if (this.report.Type == 2) {
        this.cmsData = JSON.parse(this.report.Template);
      }
      await this.updatePrintStyle();
    } catch (e) {
      throw e;
    }
  }
  async updatePrintStyle(): Promise<void> {
    await new Promise<void>((rs, rj) => {
      setTimeout(() => {
        if (this.reportContainer) {
          var styleNode = this.reportContainer.nativeElement.getElementsByTagName('style').item(0)
          if (styleNode) {
            this.reportContainer.nativeElement.removeChild(styleNode)
          }

          var ss = this.cmsData.width + ' ' + this.cmsData.height;
          var st = document.createElement('style');
          var node = document.createTextNode(
            '@page { size: ' + ss + '; margin: ' + cmsMarginCss(this.cmsData.printMargin) + '; }\n' +
            '@media print {body {margin: 0; padding: 0; color: #000; background-color: #fff;} div { margin:0;padding:0;}}'
          );

          st.appendChild(node);
          st.id = 'st';
          this.reportContainer.nativeElement.appendChild(st);
          this.cdr.markForCheck();
        }
        rs();
      }, 0);
    })

  }
  setType(type: RepeatedPresReportType) {
    this.reportType = type;
  }

  async setRegId(regId: number, currentPres?: number) {
    this.checkSeven = false;
    this.sevenHRx = [];
    this.specialHRx = [];
    // 供 getOther/getSpecial 重建報表用，僅在確定有額外張時填入
    this.tmpRepeatPresDto = null;
    var param = await this.clinicData.getParam("PRN001");
    var param2 = await this.clinicData.getParam("DRG002");
    this.printRxType = param2?.RxOrderType;
    this.IsPrintAfterSevenDispPrescription = param?.IsPrintAfterSevenDispPrescription ?? true;
    const isPrintDispPresClinic = param?.IsPrintDispPresClinic ?? false; //// 取得是否列印自調藥參數
    let newDto = new RepeatPresSetDto();
    this.clinic = UserCache.getLoginUser().Clinic;
    let userCId = UserCache.getLoginUser().CId;
    let userName = UserCache.getLoginUser().Name;
    let histAndIc = await this.histApi.getRepeatedPrescription(regId, '', this.clinic, userCId, userName, false, false);
    var opt1 = await this.histApi.getEditOptions();
    var opt2 = await this.regApi.GetEditOptions();
    let whist = histAndIc.WholeHist;
    var nFilter = histAndIc.NFilter;
    const originalHRxs = [...whist.Hist.HRxs];
    whist.Hist.HRxs = whist.Hist.HRxs.filter(x =>
      !nFilter.includes(x.SPRule)
      || x.RxCode == '/7');
    if (whist && !isNaN(whist?.Hist?.PPartRx)) whist.Hist.PPartRx = Math.abs(whist?.Hist.PPartRx);
    //有發生案例是就醫識別碼中有特殊字元，所以要處理，不然會造成BarCode印製失敗。
    //案例: g  F128Y9S3BCQCWC\u0000\u0000\u0000
    if (isSpecialChar(histAndIc.NHIRegIC.Itreatnum)) {
      histAndIc.NHIRegIC.Itreatnum = fixSpecialChar(histAndIc.NHIRegIC.Itreatnum);
    }
    let ispres = whist.Hist.CntPresTot != '' && whist.Hist.CntPresTot != null && whist.Hist.CntPresTot != undefined;
    if (ispres) {
      newDto.BackRegDate = '　回診日：' + DateHelper.formatROCDate(histAndIc.BackRegDate, false);
      newDto.DeadLine = '　截止日：' + DateHelper.formatROCDate(histAndIc.Deadline, false);
      if (histAndIc.PresDateStartAndEnds?.length > 0) {
        for (var i = 0; i < histAndIc.PresDateStartAndEnds.length; i++) {
          var pre = histAndIc.PresDateStartAndEnds.find(x => x.CntPresNo == (i + 1));
          var start = DateHelper.getFormatedDateString(pre?.StartDate, true);
          var firstReg = DateHelper.getFormatedDateString(histAndIc.FirstRegDate, true);
          if (i == 0) start = firstReg;
          var end = DateHelper.getFormatedDateString(pre?.EndDate, true);
          if (pre?.EndDate) newDto.StartStr[i] = start + '~'
          else newDto.StartStr[i] = start;
          newDto.EndStr[i] = end;
        }

        if (currentPres != null && currentPres > 0) {
          newDto.StartStr = [newDto.StartStr[currentPres - 1]];
          newDto.EndStr = [newDto.EndStr[currentPres - 1]];
        }
      }
    } else {
      newDto.BackRegDate = '';
      newDto.DeadLine = '';
    }

    if (ispres) {
      newDto.IsNormal = false;
      newDto.IsPres = true;
      this.checkSeven = whist.Hist.HRxs.some(x => x.RxCode == '/7');
    } else {
      newDto.IsNormal = true;
      newDto.IsPres = false;
      this.checkSeven = false;
    }
    if (this.checkSeven) {
      let newhrx: HistOrder[] = [];
      for (var i = 0; i < whist.Hist.HRxs.length; i++) {
        if (whist.Hist.HRxs[i].RxCode == '/7') break;
        newhrx.push(whist.Hist.HRxs[i]);
      }
      let ids = newhrx.map(x => x.Id);
      // 一次性處方只印 非自調
      this.sevenHRx = whist.Hist.HRxs.filter(x => !ids.includes(x.Id) && this.printRxType.indexOf(x.RxType) >= 0 && x.RxCode != '/7' && (isPrintDispPresClinic || x.DispTP !== OrderDispensingTypeEnum.T0_Clinic));
      // 連處
      whist.Hist.HRxs = newhrx.filter(x => this.printRxType.indexOf(x.RxType) >= 0);
    } else {
      whist.Hist.HRxs = whist.Hist.HRxs.filter(x => this.printRxType.indexOf(x.RxType) >= 0);
      if (!ispres) {  // 非連處只印 非自調; 20251124 參數決定是否列印自調藥
        if (!isPrintDispPresClinic) {
          whist.Hist.HRxs = whist.Hist.HRxs.filter(x => x.DispTP !== OrderDispensingTypeEnum.T0_Clinic);
        }
        whist.Hist.HRxs = this.takeSpecialHRx(whist.Hist.HRxs);
      }
    }


    if (this.reportType === RepeatedPresReportType.DispExam) {
      whist.Hist.HRxs = originalHRxs.filter(x =>
        (x.RxType == 6 || x.RxType == 7) && x.DispTP !== OrderDispensingTypeEnum.T0_Clinic
      );
      this.sevenHRx = [];
      this.checkSeven = false;
      this.specialHRx = [];
    }

    if (this.reportType === RepeatedPresReportType.CtrDrugs) {
      const ctrDrugLevs: string[] = [];
      if (param?.CTRDrugPrintType?.length > 0) {
        const types = param.CTRDrugPrintType;
        if (types.includes('1')) ctrDrugLevs.push('A');
        if (types.includes('2')) ctrDrugLevs.push('B');
        if (types.includes('3')) ctrDrugLevs.push('C');
        if (types.includes('4')) ctrDrugLevs.push('D');
      }

      whist.Hist.HRxs = originalHRxs.filter(x => {
        const rxDrug = histAndIc.Rx?.find(r => r.RxCode === x.RxCode);
        return x.RxCode !== '/7' && !!rxDrug?.CTRDrugs && ctrDrugLevs.includes(rxDrug.CTRDrugs);
      });
      this.sevenHRx = [];
      this.checkSeven = false;
      this.specialHRx = [];
    }

    this.data = new RepeatData(histAndIc, param, opt1, opt2, newDto);
    if (this.sevenHRx?.length > 0 || this.specialHRx?.length > 0) this.tmpRepeatPresDto = histAndIc;
  }
  /** 自 hrxs 抽出須單獨成張的醫令，回傳剩餘清單
   *  僅非連處呼叫，連處(含 /7 切分)不做此處理。
   *  抽出後 hrxs 會變空時不抽：整張本來就只有該醫令，不需再切。
   */
  takeSpecialHRx(hrxs: HistOrder[]): HistOrder[] {
    var matched = hrxs.filter(x => HistRxDispPresConst.is單獨列印(x.StdCode));
    if (matched.length == 0 || matched.length == hrxs.length) {
      return hrxs;
    }
    this.specialHRx = matched;
    return hrxs.filter(x => !HistRxDispPresConst.is單獨列印(x.StdCode));
  }
  /** 換上單獨成張的醫令，表頭比照 /7 段清為一般處方 */
  async getSpecial() {
    var param = await this.clinicData.getParam("PRN001");
    let newDto = new RepeatPresSetDto();
    newDto.IsNormal = true;
    newDto.IsPres = false;
    var opt1 = await this.histApi.getEditOptions();
    var opt2 = await this.regApi.GetEditOptions();
    this.tmpRepeatPresDto.WholeHist.Hist.HRxs = this.specialHRx;
    this.data = new RepeatData(this.tmpRepeatPresDto, param, opt1, opt2, newDto);
    this.specialHRx = [];
  }
  async getOther() {
    var param = await this.clinicData.getParam("PRN001");
    let newDto = new RepeatPresSetDto();
    newDto.IsNormal = true;
    newDto.IsPres = false;
    var opt1 = await this.histApi.getEditOptions();
    var opt2 = await this.regApi.GetEditOptions();
    this.tmpRepeatPresDto.WholeHist.Hist.HRxs = this.sevenHRx;
    this.data = new RepeatData(this.tmpRepeatPresDto, param, opt1, opt2, newDto);
    this.sevenHRx = [];
  }
  getHRx() {
    if (!this.data) {
      return [];
    }
    return this.data.getHrx();
  }
  getData(col: RepeatPresCol, arg: { tp: 'hrx', ind: number }) {
    if (!this.data) {
      return '';
    }
    var val;
    if (arg?.tp == 'hrx') {
      val = this.data.getHrxData(arg.ind, col.dataField);
    } else if (col.isQRcode) {
      val = this.data.getData(col.dataSource, col.dataField);
    }
    else {
      val = this.data.getData(col.dataSource, col.dataField);
    }
    if (col.mapping && col.mapping.Vars.length > 0 && col.mapping.Condi.length > 0) {
      var calcArg = {}
      col.mapping.Vars.forEach(v => {
        // 設定變數 取得值
        if (arg?.tp == 'hrx') {
          val = this.data.getHrxData(arg.ind, col.dataField);
          calcArg[v.n] = this.data.getHrxData(arg.ind, v.f);
        } else {
          calcArg[v.n] = this.data.getData(v.s, v.f);
        }
      })
      val = CmsColDataCalc.TestCond(col.mapping.Condi, calcArg, true)
    }
    var valStart = col?.style?.valStart ? col.style.valStart : 'left';
    var valLength = col?.style?.valLength ?? 0;
    val = this.styleforval(val, valStart, valLength);
    return val;
  }
  mergeStyle(a: RepeatPresStyle, b: RepeatPresStyle, notmerge: boolean = false) {
    if (notmerge) {
      a.border = null;
      a.borderBottom = null;
      a.borderLeft = null;
      a.borderRight = null;
      a.borderTop = null;
    }
    var r = Object.assign({}, a, b);
    return r;
  }
  sizeStyle() {
    return {
      width: this.cmsData.width,
      height: this.cmsData.height,
      padding: this.cmsData.padding,
    }
  }
  /** 送印版面的寬度，套在被 getHtml() 匯出的內層 div 上。 */
  printOffsetStyle() {
    return {
      width: this.cmsData.width,
    }
  }
  innerSizeStyle() {
    return {
      width: this.cmsData.isHelf ? '50%' : '100%',
      height: '100%',
      overflow: 'hidden'
    }
  }
  rowStyle(row: RepeatPresRow, st: RepeatPresStyle) {
    return {
      flexWrap: row.wrap ? 'wrap' : 'nowrap',
      columnGap: (row.spacing || 0) * (st?.fontSize || this.defaultFontSize) / 2 + 'px',
    }
  }
  rowGroupRepeatIndexes(row: RepeatPresRow): number[] {
    const rawCount = Number(row?.groups?.[0]?.repeatCount);
    const count = Number.isFinite(rawCount) && rawCount >= 1 ? Math.floor(rawCount) : 1;
    return Array.from({ length: count }, (_, i) => i);
  }
  getConditionData(group: RepeatPresGroup, arg?: { tp: 'hrx', ind: number }) {
    if (!this.data || !group?.displayCondSource || !group?.displayCondField) {
      return '';
    }
    if (group.displayCondSource === 'HRx') {
      return arg?.tp == 'hrx' ? this.data.getHrxData(arg.ind, group.displayCondField) : '';
    }
    return this.data.getData(group.displayCondSource, group.displayCondField);
  }
  isGroupVisible(group: RepeatPresGroup, arg?: { tp: 'hrx', ind: number }): boolean {
    if (!group?.displayCondSource || !group?.displayCondField) {
      return true;
    }
    const rawValue = this.getConditionData(group, arg);
    const current = rawValue == null ? '' : String(rawValue).trim();
    const expected = group.displayCondValue == null ? '' : String(group.displayCondValue).trim();
    switch (group.displayCondOperator) {
      case 'noValue':
        return current.length === 0;
      case 'eq':
        return current === expected;
      case 'ne':
        return current !== expected;
      case 'hasValue':
      default:
        return current.length > 0;
    }
  }
  isRowVisible(row: RepeatPresRow, arg?: { tp: 'hrx', ind: number }): boolean {
    if (!row?.groups?.length) {
      return true;
    }
    return this.isGroupVisible(row.groups[0], arg);
  }
  trackByIndex(index: number): number {
    return index;
  }
  style(st: RepeatPresStyle, value: string, isDiv = false) {
    var s = {
      marginLeft: (st?.padLeft || 0) * (st?.fontSize || this.defaultFontSize) / 2 + 'px',
      fontSize: (st.fontSize || this.defaultFontSize) + 'px',
      fontFamily: st.fontFamily || this.defaultFontFamily,
      textAlign: st.textAlign || 'left',
      textOverflow: st.textOverflow ?? 'clip',
      border: st.border > 0 ? st.border + 'px black solid' : '',
      lineHeight: st.lineheight > 0 ? (st.lineheight * 1.25 * 100).toString() + '%' : '125%',
    }
    const rowHeight = Number(st?.rowHeight);
    if (Number.isFinite(rowHeight) && rowHeight > 0) {
      // rowHeight 是樣板的實體列高(px)，讓 AI 或手動編輯的來源列高真正影響預覽與送印。
      s = Object.assign(s, {
        height: rowHeight + 'px',
      });
    }
    if (!st.border) {
      s = Object.assign(s, {
        borderTop: st.border > 0 ? '' : (st.borderTop > 0 ? st.borderTop + 'px black solid' : ''),
        borderBottom: st.border > 0 ? '' : (st.borderBottom > 0 ? st.borderBottom + 'px black solid' : ''),
        borderLeft: st.border > 0 ? '' : (st.borderLeft > 0 ? st.borderLeft + 'px black solid' : ''),
        borderRight: st.border > 0 ? '' : (st.borderRight > 0 ? st.borderRight + 'px black solid' : ''),
      });

    }
    if (st.width && !isDiv) {
      s = Object.assign(s, {
        width: st.width + 'cm',
        maxWidth: st.width + 'cm',
        minWidth: st.width + 'cm',
      });
    }
    return s;

  }
  styleBorder(st: RepeatPresStyle, value: string, isDiv = false) {
    var s = {
      textOverflow: st.textOverflow ?? 'clip',
      border: st.border,
    }
    if (!st.border) {
      s = Object.assign(s, {
        borderTop: st.border ? '' : st.borderTop,
        borderBottom: st.border ? '' : st.borderBottom,
        borderLeft: st.border ? '' : st.borderLeft,
        borderRight: st.border ? '' : st.borderRight,
      });

    }
    return s;

  }
  styleforval(
    str: any,                           // 改成 any
    valStart: 'left' | 'right' = 'left',
    valLength?: number
  ): string {
    // 先把 null / undefined 轉成空字串，其他型別轉成字串
    str = str != null ? String(str) : '';

    // 如果沒有 valLength，就回傳整個字串
    if (!valLength || valLength <= 0) return str;

    // 從左或從右截取
    return valStart === 'left' ? str.slice(0, valLength) : str.slice(-valLength);
  }
  generateQRCode(col: RepeatPresCol, arg: { tp: 'hrx', ind: number }): string {
    let retUrl: string = "";
    var val = this.getData(col, arg);
    QRCode.toDataURL(val, (err, url) => {
      if (err) {
        return;
      }
      retUrl = url;
    });
    return retUrl;
  }

  async getHtml() {
    // 讀取 innerHTML 前須先完成繪製，否則取到的是尚未套用資料的版面
    this.cdr.detectChanges();
    var html = this.reportContainer.nativeElement.innerHTML;
     if (this.sevenHRx?.length > 0 && this.tmpRepeatPresDto && this.IsPrintAfterSevenDispPrescription && this.regApi.isPrintSeven) {
      await this.getOther();
      this.cdr.detectChanges();
      html = html + this.reportContainer.nativeElement.innerHTML;
      // Task 17984: X7030 P.37=Z時，/7以下只需要印一張
      // 列印第1張時記錄為true
    }
    // 單獨成張的醫令；僅非連處會有值，表頭欄位本就是一般處方狀態
    if (this.specialHRx?.length > 0 && this.tmpRepeatPresDto) {
      await this.getSpecial();
      this.cdr.detectChanges();
      html = html + this.reportContainer.nativeElement.innerHTML;
    }
    return html;
  }
  getLimitCountPerPage() {
    //每頁限制筆數
    return 45;
  }
}
